import React, { useEffect, useState } from 'react';
import { Box, Divider } from '@mui/material';
import Header from 'components/Header';
import { useParams } from 'react-router-dom';
import { getVisitRequestActionPublicAPI } from '../../apis/visitRequest/visitRequestAPI';

export default function PublicVisitRequest() {
  const { action, token, user } = useParams(); // URL에서 ID 값 가져오기
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const actionParam = action || '';
    const tokenParam = token || '';
    const userParam = Number(user) || 0;
    if (['approve', 'reject'].includes(actionParam) && tokenParam) {
      getVisitRequestActionPublicAPI(actionParam, tokenParam, userParam)
        .then((res) => {
          if (res.code === 200) {
            if (actionParam === 'approve') {
              setMessage('승인처리 되었습니다.')
            } else if (actionParam === 'reject') {
              setMessage('반려처리 되었습니다.')
            }
          } else {
            res.message && setMessage(res.message);
          }
        })
        .catch((err) => {
          err.message && setMessage(err.message);
        });
    }

    return () => {
      setMessage('');
    };
  }, [action, token]);

  return (
    <Box flexGrow={1} display="flex" flexDirection="column">
      {/* Header를 클릭하면 메인페이지로 이동 */}
      <Header />
      {/* 경계선 */}
      <Divider />
      <Box flexGrow={1} width="100%" display="flex" alignItems="center" justifyContent="center">
        {message && <h1>{message}</h1>}
      </Box>
      {/*<Footer maxWidth={1920} />*/}
    </Box>
  );
}
